function getAliaDiscountData() {
  try {
    let actions = JSON.parse(sessionStorage.getItem('alia-user-actions') || '[]');
    if (actions.length == 0) {
        actions = JSON.parse(localStorage.getItem('alia-user-actions') || '[]');
    }
    let percent = null;
    let code = null;

    actions.forEach(a => {
      if (a.type === 'setProperty') {
        const key = a.data?.property?.toLowerCase();

        if (key.includes('percent')) percent = a.data.value;
        if (key.includes('coupon') || key.includes('code')) code = a.data.value;
      }
    });

    return { percent, code };
  } catch {
    return {};
  }
}

document.addEventListener('click', function (e) {
  if (e.target.closest('.alia-just-for-you__close')) {
    const banner = document.querySelector('.alia-just-for-you');
    console.log(banner)
    if (banner) banner.classList.add('hidden');

    sessionStorage.setItem('alia_banner_closed', 'true');
  }
});

window.updateDiscountUI = function () {
  const { percent, code } = getAliaDiscountData();

  if (!percent && !code) return;

  // Badge
  document.querySelectorAll('.alia-discount-badge').forEach(el => {
    if (percent) el.textContent = `${percent}% OFF`;
    el.classList.remove('hidden');
  });

  // Info banner
  document.querySelectorAll('.alia-discount-info').forEach(el => {
    if (percent && code) {
      el.innerHTML = `<span class="discount-off">${percent}%</span> off sitewide with code <strong>${code}</strong>`;
    }
    el.classList.remove('hidden');
  });

  // Product Cards
  document.querySelectorAll('.product-label--alia').forEach(el => {
    if (percent) el.textContent = `${percent}% OFF`;
    el.classList.remove('hidden');
  });

  // Just for you banner
  const banner = document.querySelector('.alia-just-for-you');
  const text = document.querySelector('.alia-offer-text');

  if (banner && text) {
    text.innerHTML = `Save ${percent}% sitewide. Use Code: <strong>${code}</strong>`;
    banner.classList.remove('hidden');
  }

  // Override announcement bar text
  document.querySelectorAll('.announcement__text--discount .rte')
  .forEach(el => {
    if (!el.dataset.originalText) {
      el.dataset.originalText = el.innerHTML;
    }
  });

  const isMobile = window.innerWidth < 1200;
  document.querySelectorAll('.announcement__text--discount .rte')
  .forEach(el => {
    if (isMobile) {
      el.innerHTML = `
        <p>
          <strong>Exclusive Offer:</strong>
          Save ${percent}% sitewide. Use code: <strong>${code}</strong>
        </p>
      `;
    } else {
      el.innerHTML = el.dataset.originalText;
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  window.updateDiscountUI();
});